










































import { Component, Vue, Prop } from "vue-property-decorator";
import { Format } from "../../../core/helpers/formatHelper";
import { Settings } from "../../../core/services/configService";
import { CrudService } from "../../../core/services/crudService";
import store from "../../../core/store";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import { DateHelper } from "../../../core/helpers/dateHelper";

@Component({
  components: {
    VueSlickCarousel,
  },
})
export default class ActivitiesBanner extends Vue {
  @Prop() title!: string;
  slides: any[] = [];
  carouselSettings: any = null;

  async mounted() {
    let url = `${Settings.HostName}/api/publicactivities/list`;
    let data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash");
      return;
    }
    this.slides = data.model;

    this.carouselSettings = {
      arrows: false,
      dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      speed: 3000,
      autoplaySpeed: 3000,
      cssEase: "ease-in-out",
    };
  }

  formatCurrency(number: number) {
    if (number === undefined) {
      return "";
    }
    return Format.formatCurrency(number.toString());
  }

  formatDate(date: string) {
    return DateHelper.toCultureString(date);
  }

  getImageProduct(name: string) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
  }
}
